// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"8232434a","352":"d6092027","397":"eada270c","410":"b53aea0f","412":"f8f19c1c","534":"d3c7f4af","964":"fbe8d21d"}[chunkId] + ".chunk.js";
};